import { render } from "./MenuDesktop.vue?vue&type=template&id=85e48630&lang=pug"
import script from "./MenuDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDesktop.vue?vue&type=script&setup=true&lang=js"

import "./MenuDesktop.vue?vue&type=style&index=0&id=85e48630&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__